<template>
  <section class="overview" v-if="ready">
    <v-container>
      <h1 class="header-title optus-highlight optus-highlight--yellow">
        My Dashboard&nbsp;
      </h1>
      <overview-card
        class="mt-3"
        :available-workshops="activeLessons"
        :completed-lessons="completedLessons"
      />
      <notifications type="users" />
      <v-card class="my-4" v-if="todoList && todoList.length">
        <v-toolbar color="primary" flat dark>
          <v-toolbar-title>To do list</v-toolbar-title>
        </v-toolbar>
        <v-row
          justify="space-between"
          class="to-do-row"
          v-for="(todo, key) in todoList"
          :key="key"
        >
          <v-col cols="8" v-if="todo.in_progress == 0">
            You have to start {{ todo.lesson }}
          </v-col>
          <v-col v-else> You have started {{ todo.lesson }} </v-col>
          <v-col cols="4">
            <v-btn
              color="secondary"
              class="primary--text"
              @click="startLesson(todo)"
            >
              {{
                todo.in_progress == 0
                  ? `click here to start ${lessonTerm}`
                  : `click here to continue ${lessonTerm}`
              }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <!-- <lesson-completed /> -->
      <!-- <lessons-table /> -->
      <v-row>
        <v-col cols="12" md="6"> </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import Lesson from '@/modules/lesson/models/Lesson'
import Class from '@/modules/class/models/Class'
import Auth from '@/modules/auth/models/Auth'
import Student from '@/modules/student/models/Student'
// import LessonCompleted from './overview/LessonCompleted'
// import StudentInviteNotAccepted from './overview/StudentInviteNotAccepted'
// import LessonsTable from '@/modules/auth/views/dashboard/LessonsTable'
import Notifications from './overview/Notifications'
import { mapState } from 'vuex'
import OverviewCard from '@/modules/auth/views/dashboard/OverviewCard'
// import ClassQuizScore from '@/modules/teacher/views/dashboard/overview/ClassQuizScore'

export default {
  name: 'Overview',
  components: {
    // LessonCompleted,
    Notifications,
    // StudentInviteNotAccepted,
    // LessonsTable,
    OverviewCard
    // ClassQuizScore
  },
  data() {
    return {
      todoList: [],
      ready: false
    }
  },
  computed: {
    ...mapState(['bucketUrl', 'lessonTerm']),
    schoolInfo() {
      if (!this.me) return ''

      if (this.me.acara_id) {
        return this.me.school_name
      }

      const schoolMetadata = this.me.school_metadata

      if (this.me.role === 'casual') {
        return 'Postcode: ' + schoolMetadata.postcode
      }

      if (
        this.me.role === 'teacher' ||
        this.me.role === 'school_leader_principal'
      ) {
        return schoolMetadata.school_text + ' - ' + schoolMetadata.country
      }

      if (
        this.me.role === 'home_distance' ||
        this.me.role === 'organization_company'
      ) {
        return schoolMetadata.school_text
      }

      if (this.me.role === 'pre_service_teacher') {
        return schoolMetadata.university
      }

      return 'School Info'
    },
    me() {
      return Auth.query()
        .where('type', 'student')
        .first()
    },
    activeLessons() {
      if (Auth.query().first())
        return Auth.query().first().student_meta.assigned_lessons
      return 0
    },
    completedLessons() {
      if (Auth.query().first())
        return Auth.query().first().student_meta.completed_lessons
      return 0
    },
    classCount() {
      return Class.query().count()
    },
    ...mapState(['bucketUrl'])
  },
  async mounted() {
    let type = this.$route.meta.type
    if (type == 'user') type = 'student'
    this.$store.state.loading = true
    await Class.dispatch('fetchForStudent')
    await Lesson.dispatch('fetch', type)
    // this.todoList = await Student.dispatch('todoList')
    let list = await Student.dispatch('todoList')
    for (let i = 0; i < list.length; i++) {
      if (this.getLessonSlides(list[i].lesson).length) {
        this.todoList.push(list[i])
      }
    }
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  },
  methods: {
    getLessonSlides(lessonName) {
      let lessons = Lesson.query()
        .where('name', lessonName)
        .get()
      return lessons.length ? lessons[0].lesson_slides : []
    },
    async startLesson(todo) {
      if (!todo.user_lesson_id) {
        const payload = {
          customClassId: todo.custom_class_id,
          slug: todo.lesson_slug
        }

        try {
          const userLesson = await Student.dispatch('startClassLesson', {
            payload: payload
          })
          this.redirectToLesson(userLesson.id, userLesson.lesson.slug)
        } catch (error) {
          if (error.status === 422) {
            if (
              error.data.message ===
              'Lesson in progress for this class and this student.'
            ) {
              this.redirectToLesson(todo.user_lesson_id, todo.lesson_slug)
            }
          }
        }
      } else {
        this.redirectToLesson(todo.user_lesson_id, todo.lesson_slug)
      }
    },
    redirectToLesson(userLessonId, slug = '') {
      let link = ''
      let base_url = window.location.origin
      if (process.env.NODE_ENV === 'production') {
        link = 'lessons/'
      } else {
        base_url = process.env.VUE_APP_LESSON
      }
      if (this.$store.state.isSDECC == 1) {
        window.open(
          `${base_url}/${link}user/?slug=${slug}&user_lesson_id=${userLessonId}`
        )
      } else {
        window.open(
          `${base_url}/${link}student/?slug=${slug}&user_lesson_id=${userLessonId}`
        )
      }
    }
  }
}
</script>

<style lang="scss">
.overview {
  .to-do-row {
    margin: 0;
    overflow: auto;
  }
}
</style>
